var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip rounded-pill",class:{selected: _vm.selected},style:({opacity: _vm.opacity ? _vm.opacity : 0.75}),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }